import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CusInput from "../../../mui/custom_input/CusInput.jsx";
import IconAddress from "../../../mui/JSXIcons/IconAddress.jsx";

export default function AccField() {
  const { t } = useTranslation();

  const [address, setAddress] = useState("");

  return (
    <CusInput
      iconJSXstart={<IconAddress />}
      defaultValue={address}
      name={"accNumber"}
      onChange={(e) => setAddress(e.target.value)}
      placeholder={`${t("Account number")}`}
      required
    />
  );
}
